import React from 'react';


export default function Chip(props) {
  return (
    <div className='chip'>
      <div className='chip-labels'>
        {props.sublabel && <div className='chip-name'>{props.sublabel}</div>}
        <div className='text'>{props.label}</div>
      </div>
      <button className='delete' onClick={props.onDelete}>
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
          <line x1="1" y1="1" x2="9" y2="9"/><line x1="9" y1="1" x2="1" y2="9"/>
        </svg>
      </button>
    </div>
  );
}
